import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import type { PaycodeCombination } from 'repository/timekeeper/@types/PaycodeCombination'
import { createPycodesCombination } from 'utils/PaycodesCombination'
import { PaycodesCombinationFormDialog, type PaycodesCombinationSubmitPayload } from './PaycodesCombinationFormDialog'
import { usePaycodesOptions } from 'hooks/paycodesCombinations/usePaycodesOptions'

interface Props {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    reloading: () => void
    rows: PaycodeCombination[]
}

const AddPaycodesCombination = ({ open, setOpen, reloading, rows }: Props) => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)
    const { paycodes, loadingPaycodes } = usePaycodesOptions({ enabled: open, reloadKey: open })

    const handleAdd = (body: PaycodesCombinationSubmitPayload) => {
        setLoading(true)
        createPycodesCombination(setLoading, body)
            .then(() => {
                enqueueSnackbar(t('settings.paycodes_combination.dialog.alerts.add.success'), { variant: 'success' })
                setOpen(false)
                reloading()
            })
            .catch((error: unknown) => {
                console.error(error)
                enqueueSnackbar(t('settings.paycodes_combination.dialog.alerts.add.error'), { variant: 'error' })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <PaycodesCombinationFormDialog
            open={open}
            onClose={handleClose}
            onSubmit={handleAdd}
            title={t('settings.paycodes_combination.dialog.titles.add')}
            saveButtonText={t('general.buttons.add')}
            rows={rows}
            paycodesOptions={paycodes}
            loadingPaycodes={loadingPaycodes}
            isSaving={loading}
            initialValues={{}}
            requiredPermissions={['timekeeper.GetPaycodes']}
            descriptionRows={2}
        />
    )
}

export { AddPaycodesCombination }
